import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class InventoryConversionActivity extends Component {
	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/InventoryConversion/InventoryConversionBrowser")
	}

	render() {
		return (
			<Activity 
				name="InventoryConversion"
				RenderedComponent={this.RenderedComponent}
				context="InventoryConversion"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(InventoryConversionActivity)
